import ContentWorkPage from "./ContentWork"
import GalaPage from "./Gala"
import KomusPage from "./Komus"
import ProductPage from "./Product"
import RelefPage from "./Relef"
import SamsonPage from "./Samson"
import SimaLandPage from "./SimaLand"
import StocksPage from "./StocksContent"
import StocksUpdatePage from "./StocksUpdateContent"
import StopBrandsPage from "./StopBrands"

const ProviderPages = {
    ContentWork: ContentWorkPage,
    SimaLand: SimaLandPage,
    Samson: SamsonPage,
    Komus: KomusPage,
    Relef: RelefPage,
    Gala: GalaPage,
    Stocks: StocksPage,
    Product: ProductPage,
    StopBrands: StopBrandsPage,
    StocksUpdate: StocksUpdatePage,
}

export default ProviderPages